import PatientAddress from "./PatientAddress";
export default PatientAddress;
